import { EventEmitter } from 'events';

class ModalManager extends EventEmitter {
  constructor() {
    super();
    this.modalInfo = {
      title: "",
      message: "",
      buttonName: "",
      onClick: () => {},
      BodyComponent: () => null,
      noSubmit: false,
      noCancel: false,
      preventOutsideClose: false,
      modalStyle: null,
      contentStyle: null,
    };
  }

  addChangeListener(callback) {
    this.addListener("change", callback);
  }

  removeChangeListener(callback) {
    this.removeListener("change", callback);
  }

  emitChange() {
    this.emit("change", this.modalInfo);
  }

  confirm(
    message,
    title,
    buttonName,
    onClick,
    BodyComponent = null,
    noCancel,
    noSubmit,
    options = {},
  ) {
    const opts = options || {};
    this.modalInfo.title = title;
    this.modalInfo.message = message;
    this.modalInfo.buttonName = buttonName;
    this.modalInfo.BodyComponent = BodyComponent;
    this.modalInfo.onClick = onClick;
    this.modalInfo.noCancel = noCancel;
    this.modalInfo.noSubmit = noSubmit;
    this.modalInfo.preventOutsideClose = Boolean(opts.preventOutsideClose);
    this.modalInfo.modalStyle = opts.modalStyle || null;
    this.modalInfo.contentStyle = opts.contentStyle || null;
    this.emitChange();
  }
}

export default new ModalManager();